import { render, staticRenderFns } from "./livescanversion.vue?vue&type=template&id=f54cbc44&scoped=true&"
import script from "./livescanversion.vue?vue&type=script&lang=js&"
export * from "./livescanversion.vue?vue&type=script&lang=js&"
import style0 from "./livescanversion.vue?vue&type=style&index=0&id=f54cbc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54cbc44",
  null
  
)

export default component.exports